module.exports = __webpack_public_path__ + "static/media/asset_whatsup.1a02d5ab.svg";